/**************************************************
 * Nombre:       Seccion_Cuentas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_CONTAR_ARR,
    CASILLA_ESTADO,
    CASILLA_FECHA_DATO,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ArticleOutlined, ManageSearch, MoveUpOutlined} from "@mui/icons-material";
import {ESTADOCUENTA} from "../../Constantes";
import Dialogo_Cuentas from "../Dialogos/Cuentas/Dialogo_Cuentas";
import Dialogo_Cuenta_Documentos from "../Dialogos/Cuentas/Dialogo_Cuenta_Documentos";
import Dialogo_Cuentas_Rango from "../Dialogos/Cuentas/Dialogo_Cuentas_Rango";


const Seccion_Cuentas = () => {
    const {props, setData, setNumeroFilas, cargarNuevamente} = useObtenerColleccionTabla2025({coleccion: 'cuentas'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Cuentas,
        titulo: 'Detalles de cuenta',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoDocs, abrir: abrirDoc} = useDialogo({
        Componente: Dialogo_Cuenta_Documentos,
        titulo: 'Documentos',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoRango, abrir: abrirRango} = useDialogo({
        Componente: Dialogo_Cuentas_Rango,
        titulo: 'Rango',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        // console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'documentos':
                abrirDoc(data)
                break
            case 'rango':
                abrirRango(data)
                break
            default :
                abrir(data)
        }
    }


    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoDocs/>

                <DialogoRango/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista de cuentas de usuarios'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Cuentas

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO
    },
    {
        nombre: 'Correo',
        direccion: 'left',
        propiedad: 'correo',
        tipo: CASILLA_TEXTO
    },
    {
        nombre: 'Pais',
        direccion: 'left',
        propiedad: 'pais',
        tipo: CASILLA_TEXTO
    },
    {
        nombre: 'Documentos',
        direccion: 'left',
        propiedad: 'documentos',
        tipo: CASILLA_CONTAR_ARR
    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOCUENTA
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Documentos',
        id: 'documentos',
        icono: ArticleOutlined
    },
    {
        nombre: 'Rango',
        id: 'rango',
        icono: MoveUpOutlined
    }
]